module.exports = __webpack_public_path__ + "static/media/mainpic.7a19522e.jpg";